import { useContext, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import Tabela from '../../Misc/Tabela/Tabela';
import { ChamadosSourcingProvider, useChamadosSourcingContext } from './pa_chamados_sourcing_context';
import styles from './pa_chamados_sourcing.module.scss';
import ModalNovoChamado from './componentes/pa_chamados_sourcing_modal_novo_chamado';
import FiltroChamadosSourcing from './componentes/pa_chamados_sourcing_filtros';
import ChamadoQualidadePA from './componentes/pa_chamados_sourcing_modal_detalhes';
import { toBrDateWithTime } from '../../../utils/dateUtils';
import { formatarCNPJ } from '../../../utils/misc_utils';

function ChamadosSourcingInterno() {
  const {
    chamados,
    setShowModalNovoChamado,
    showDetalhes,
    abrirDetalhesChamado,
    tipoFormulario,
    setTipoFormulario,
    loadingMainTable
  } = useChamadosSourcingContext();
  const [modalSelecao, setModalSelecao] = useState(false);

  const colunas = [
    {
      name: '',
      cell: row => (
        <Button
          size="sm"
          style={{ fontWeight: '500' }}
          onClick={() => abrirDetalhesChamado(row)}
        >
          Detalhes
        </Button>
      )
    },
    { name: 'Chamado', selector: row => row.id_chamado },
    { name: 'Data Criação', selector: row => toBrDateWithTime(row.criado_em), width: '200px' },
    { name: 'Categoria', selector: row => row.tipo_chamado, width: '200px' },
    {
      name: 'Status',
      selector: row => {
        let backgroundColor;

        switch (row.status_cq) {
          case 'Cancelado':
            backgroundColor = '#ff6449ab';
            break;
          case 'Novo':
            backgroundColor = '#ff6449ab';
            break;
          case 'Em andamento':
            backgroundColor = '#ffc107ab';
            break;
          case 'Finalizado':
            backgroundColor = '#28a745ab';
            break;
          default:
            backgroundColor = '#dee2e6';
        }

        return (
          <div
            style={{ backgroundColor }}
            className={styles.status_wrapper}
          >
            {row.status_cq}
          </div>
        );
      },
      width: '200px'
    },
    { name: 'Atribuído p/', selector: () => 'qualidadepa.assistente', width: '200px' },
    { name: 'Resultado C.Q.', selector: row => row.resultado, width: '200px' },
    { name: 'Pontos Defeito', selector: row => row.total_pontos, width: '200px' },
    { name: 'Fornecedor Principal', selector: row => row.nome_fantasia_fornecedor_principal || row.nome_fantasia_fornecedor, width: '200px' },
    { name: 'CNPJ Fornecedor Principal', selector: row => (formatarCNPJ(row.cnpj_fornecedor_principal) || formatarCNPJ(row.cnpj_fornecedor)), width: '200px' },
    { name: 'Tipo Fornecedor', selector: row => row.tipo_fornecedor, width: '200px' },
    { name: 'Marca', selector: row => row.marca, width: '200px' },
    { name: 'Tipo de Amostra', selector: row => row.tipo_amostra, width: '200px' },
    { name: 'Tipo de Produto', selector: row => row.tipo_produto, width: '200px' },
    { name: 'Dato de Conclusão', selector: row => toBrDateWithTime(row.finalizado_em), width: '200px' }
  ];

  const abrirFormulario = (tipo) => {
    setTipoFormulario(tipo);
    setModalSelecao(false);
    setShowModalNovoChamado(true);
  }

  return (
    <section style={{ margin: '20px', display: 'flex', flexDirection: 'column', gap: '20px' }}>
      <section className={styles.flex_title} style={{ justifyContent: 'space-between' }}>
        <h4 className={styles.title}>Follow up - Chamados Sourcing PA</h4>
        <Button
          style={{ fontWeight: '500' }}
          variant="outline-secondary"
          onClick={() => setModalSelecao(true)}
        >
          Novo Chamado
        </Button>
      </section>

      <section style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
        <FiltroChamadosSourcing />
      </section>

      <section>
        <Tabela
          data={chamados}
          columns={colunas}
          pagination
          highlightOnHover
          pending={loadingMainTable}
        />
      </section>

      {
        tipoFormulario &&
        <ModalNovoChamado />
      }
      {
        showDetalhes &&
        <ChamadoQualidadePA />
      }

      <Modal
        show={modalSelecao}
        onHide={() => setModalSelecao(false)}
        size="md"
        backdrop="static"
        fullscreen='lg-down'
      >
        <Modal.Header style={{ fontWeight: '500' }} closeButton>Escolha o tipo de tipo de chamado</Modal.Header>
        <Modal.Body
          style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}
        >
          <Button
            style={{ fontWeight: '500' }}
            onClick={() => abrirFormulario(101)}
          >
            Novo Fornecedor
          </Button>
          <Button
            style={{ fontWeight: '500' }}
            onClick={() => abrirFormulario(102)}
          >
            Fornecedor Atual Desenvolvimento
          </Button>
        </Modal.Body>
      </Modal>
    </section>
  );
}

export default function ChamadosSourcing() {
  return (
    <ChamadosSourcingProvider>
      <ChamadosSourcingInterno />
    </ChamadosSourcingProvider>
  );
}
